import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { TextHelper } from '../helpers/text.helper';

@Directive({
  selector: 'mat-select, button[mat-menu-item], a[mat-menu-item]',
  standalone: false,
})
export class TestIdDirective implements AfterViewInit {
  private readonly el = inject(ElementRef<HTMLElement>);

  ngAfterViewInit(): void {
    const el = this.el.nativeElement as HTMLElement;
    if (el.hasAttribute('data-testid') || this.parentHasTestId(el)) {
      return;
    }
    const derived = this.deriveId(el);
    if (derived) {
      el.setAttribute('data-testid', derived);
    }
  }

  private parentHasTestId(el: HTMLElement): boolean {
    let parent = el.parentElement;
    while (parent) {
      if (parent.tagName.includes('-')) {
        return parent.hasAttribute('data-testid');
      }
      parent = parent.parentElement;
    }
    return false;
  }

  private deriveId(el: HTMLElement): string | null {
    const source =
      el.getAttribute('formcontrolname') ??
      el.getAttribute('name') ??
      el.getAttribute('placeholder') ??
      el.getAttribute('aria-label') ??
      el.textContent?.trim() ?? null;
    return source ? TextHelper.toKebab(source) : null;
  }
}
